import StepIndicator from '../vue-components/StepIndicator.vue';

(function () {
    'use strict';

    angular.module('thankview.global')
        .value('stepIndicator', StepIndicator)
        .controller('PurchaseFlowController', ['$scope', 'ajax', '$window', '$rootScope', '$document', '$q', 'logEventService', '$timeout', function ($scope, ajax, $window, $rootScope, $document, $q, logEventService, $timeout) {
            const pricing = config.params.pricing;
            var stripe = null;
            var cardCvcElement = null;
            var cvcErrorElement = null;
            $scope.creditCard = config.params.creditCard;
            $scope.flow = config.params.flow ? config.params.flow : 'upgrade';
            $scope.businessId = config.params.businessId;
            if ($scope.flow === 'upgrade' && !$scope.businessId) {
                $scope.businessId = config.params.package.pivot.business_id;
            }
            $scope.stepNames = ['Plan', 'Payment', 'Complete'];
            $scope.stepIndex = 0;
            $scope.step = $scope.stepNames[$scope.stepIndex];
            $scope.allPackages = [];
            $scope.contactExtras = pricing.contacts;
            $scope.extras = { contacts: 0, price: 0, label: '' };
            $scope.currentStep = 0;
            $scope.contactIntervals = [];
            $scope.pricePerContact = [];
            $scope.clickedValidate = false;
            $scope.newCreditCardSelected = false;
            $scope.termsValid = false;
            $scope.formSubmitted = false;
            $scope.selectPackageValid = true;
            $scope.isSafari = $window.config.safari;

            // For custom events tracking
            var logEventPLGFlow = 'F';
            switch ($scope.flow) {
                case 'purchase':
                    logEventPLGFlow = 'N';
                    break;
                case 'upgrade':
                    logEventPLGFlow = 'P';
                    break;
                default:
                    break;
            }

            angular.forEach(pricing.tiers, (tier, key) => {
                tier.key = key;
                tier.monthlyPrice = Math.floor(tier.price / 12);
                $scope.allPackages.push(tier);
            });

            $scope.selectedPackage = $scope.allPackages[0];
            // Change to what user selected if coming from pricing page
            // ex. .../purchasePlan?plan=pro
            if ($window.location.search.indexOf('plan') > -1) {
                var plan = $window.location.search.split('=')[1];

                // Account for marketing codes in the url
                if (plan.indexOf('starter') > -1) {
                    plan = 'starter';
                } else if (plan.indexOf('pro') > -1) {
                    plan = 'pro';
                }

                $scope.allPackages.forEach((pack) => {
                    if (plan.toUpperCase() === pack.name.toUpperCase()) {
                        $scope.selectedPackage = pack;
                    }
                });
            }

            $scope.reloadWarning = function (e) {
                if ($scope.step === 'Complete' || $scope.flow === 'upgrade') {
                    return false;
                }
                var message = 'Changes you made may not be saved.';

                e = e || $window.event;
                if (e) e.returnValue = message;
                return message;
            };

            angular.element($window).on('beforeunload', $scope.reloadWarning);

            $scope.price = $scope.selectedPackage.price.toString();
            if ($scope.flow === 'upgrade') {
                $scope.price = '0';
                $scope.extendDateShort = config.params.package.subscription_end_date;
            }
            $scope.selectedContactExtra = $scope.contactExtras[0];
            if ($scope.flow === 'extend') {
                $scope.extendDateShort = config.params.extendDateShort;
                $scope.extendDateFull = config.params.extendDateFull;
                $scope.renewDate = config.params.renewDate;
            }

            $scope.setContactExtras = (extra) => {
                $scope.currentStep = extra;
                $scope.extras = { contacts: $scope.contactExtras[extra].contacts, price: $scope.contactExtras[extra].price, label: $scope.contactExtras[extra].label };
                $scope.selectedContactExtra = $scope.contactExtras[extra];
                $scope.$applyAsync();
            };

            $scope.setPackage = (pack) => {
                logEventService.addEvent(logEventPLGFlow + ' - ' + pack.name + ' Plan clicked', 'PLG');
                if (pack.name === 'Premium') {
                    if ($scope.businessId) {
                        $scope.sendEmailToSales('upgrade');
                    } else {
                        // For a new user (no existing portal), redirect to set up demo page
                        $window.open('https://content.thankview.com/custom-pricing', '_blank');
                    }
                } else if ($scope.flow === 'upgrade' && $scope.currentPlan === 'Pro' && pack.name !== 'Pro') {
                    logEventService.addEvent(logEventPLGFlow + ' - Downgrade displayed', 'PLG');
                    $scope.sendEmailToSales('downgrade');
                } else {
                    $scope.selectPackageValid = true;
                    $scope.selectedPackage = pack;
                    $scope.getPrice();
                }
            };

            $scope.sendEmailToSales = function (type) {
                const deferred = $q.defer();
                let message = '';
                var params = {};

                params.buttons = [
                    { name: 'Go Back', colorClass: 'btn--cancel', callback: function () { deferred.reject(); } },
                    { name: $scope.flow === 'upgrade' ? 'Talk to Support' : 'Talk to Sales', callback: function () { deferred.resolve(); } },
                ];

                switch (type) {
                    case 'payment':
                        params.header = 'Pay a Different Way';
                        message = 'If you would like to pay for a subscription using another payment method, ';
                        break;
                    case 'downgrade':
                        params.header = 'Downgrade your Subscription';
                        message = 'To downgrade your subscription, ';
                        break;
                    case 'upgrade':
                        params.header = 'Upgrade to Premium';
                        message = 'To upgrade your subscription to Premium, ';
                        break;
                    default:
                        break;
                }
                message += 'please click the button below and someone on our team will help you out!';

                $rootScope.$broadcast('open-message-confirm', message, deferred, params);
                deferred.promise.then(function () {
                    $rootScope.$broadcast('open-loading');
                    if (type === 'payment') {
                        var postLink = '/api/business/newUserContactSales/email';
                        var postParams = {};
                        if ($scope.businessId) {
                            postLink = '/api/business/' + $scope.businessId + '/differentPayment/email';
                        } else {
                            var planInfo = {
                                tier: $scope.selectedPackage.name,
                                extra: $scope.selectedContactExtra.label,
                                totalCost: $scope.selectedPackage.price + $scope.selectedContactExtra.price,
                            };
                            postParams = {
                                plan: planInfo,
                                setupForm: $scope.setupPurchaseForm,
                            };
                        }

                        ajax.post(postLink, postParams).then(function () {
                            params = {
                                header: 'Our Team will Reach Out Shortly!',
                            };
                            $rootScope.$broadcast('close-loading');
                            $rootScope.$broadcast('open-message', 'Thanks for reaching out to pay for a subscription using another payment method! Our team will reach out shortly to assist you.', params);
                        });
                    } else {
                        ajax.post('/api/business/' + $scope.businessId + '/updatePackage/email', { type: type }).then(function () {
                            if (type === 'upgrade') {
                                logEventService.addEvent(logEventPLGFlow + ' - Prem Talk to Sales clicked', 'PLG');
                            } else {
                                logEventService.addEvent(logEventPLGFlow + ' - Downgrade Talk to Sales clicked', 'PLG');
                            }
                            params = {
                                header: 'Our Team will Reach Out Shortly!',
                            };
                            $rootScope.$broadcast('close-loading');
                            $rootScope.$broadcast('open-message', 'Thanks for reaching out to ' + type + ' your plan! Our team will reach out shortly to assist you.', params);
                        });
                    }
                });
            };

            $rootScope.setPLGFlowForTracking = (name) => {
                logEventPLGFlow = name;
            };

            $scope.init = function () {
                $scope.getContactIntervalsAndPrice();
                if (!$scope.businessId) {
                    $scope.stepNames = ['Plan', 'Setup', 'Payment', 'Complete'];
                    $scope.setUpPageObjs();
                }

                if (config.params.package) {
                    $scope.currentPlan = config.params.package.name.split(' ')[0];
                    $scope.allPackages.forEach((pack) => {
                        if ($scope.currentPlan === pack.name) {
                            $scope.selectedPackage = pack;
                            $scope.currentPackage = pack;
                        }
                    });
                }

                // trigger abandoned choosing plan step
                if ($scope.businessId && $scope.flow === 'purchase') {
                    ajax.post('/freeTrial/leftPlanStep', { business_id: $scope.businessId });
                }
            };

            $scope.getIndustries = () => {
                ajax.get('/api/industries').then(function (data) {
                    $scope.industries = data;
                });
            };

            $scope.setIndustry = ($event, industry) => {
                $scope.industrySet = true;
                $scope.industryError = false;
                $scope.setupPurchaseForm.orgType = industry;
            };

            $scope.continue = ($event) => {
                if ($scope.step !== 'Payment') {
                    const logEventName = logEventPLGFlow + ' - ' + $scope.step + ' Continue clicked';
                    logEventService.addEvent(logEventName, 'PLG');
                }
                if ($scope.flow === 'upgrade' && $scope.currentPlan === $scope.selectedPackage.name) {
                    $scope.selectPackageValid = false;
                    if ($scope.scrollToBottom) {
                        $scope.scrollToBottom();
                    }
                    return;
                }

                $event.preventDefault();
                $scope.scrollToTop();

                if ($scope.step === 'Setup') {
                    $scope.validateSetupPage();
                } else if ($scope.step === 'Payment') {
                    logEventService.addEvent(logEventPLGFlow + ' - Payment Submit clicked', 'PLG');
                    $scope.formSubmitted = true;
                    if (!$scope.newCreditCardSelected && $scope.flow === 'upgrade') {
                        if (!$scope.termsValid) return;
                        if (cardCvcElement) {
                            stripe.createToken('cvc_update', cardCvcElement).then(function (result) {
                                if (result.error) {
                                    cvcErrorElement.textContent = '* ' + result.error.message;
                                    cvcErrorElement.classList.add('visible');
                                    return;
                                }
                                $scope.submitExtension(result.token);
                            });
                        } else {
                            $scope.submitExtension();
                        }
                    } else {
                        $scope.$broadcast('stripe-form-submit', $scope.termsValid);
                    }
                } else {
                    $scope.stepIndex += 1;
                    $scope.step = $scope.stepNames[$scope.stepIndex];
                    if ($scope.step === 'Payment' && $scope.flow === 'upgrade') {
                        $scope.loadStripe();
                    }
                }

                // trigger abandoned step
                if ($scope.businessId && $scope.step === 'Payment' && $scope.flow === 'purchase') {
                    ajax.post('/freeTrial/leftPaymentStep', { business_id: $scope.businessId });
                }
            };

            $scope.termsAreValid = function () {
                $scope.termsValid = $document[0].getElementById('agreeTerms-checkbox').checked;
                logEventService.addEvent(logEventPLGFlow + ' -  Payment Terms clicked', 'PLG');
            };

            $scope.goBack = ($event) => {
                $event.preventDefault();
                $scope.scrollToTop();

                logEventService.addEvent(logEventPLGFlow + ' - ' + $scope.step + ' Go Back', 'PLG');
                $scope.stepIndex = Math.max($scope.stepIndex - 1, 0);
                $scope.step = $scope.stepNames[$scope.stepIndex];
            };

            $scope.closeUpgradeOverlay = () => {
                if ($scope.step === 'Payment') {
                    var params = {};
                    params.header = 'Leaving already?';
                    params.buttons = [
                        { name: 'Go Back', colorClass: 'btn--cancel', callback: function () { $rootScope.$broadcast('close-message'); } },
                        { name: 'Exit', callback: function () { $scope.close(); } },
                    ];
                    $rootScope.$broadcast('open-message-confirm', 'Are you sure you want to leave this page without confirming your payment?', null, params);
                } else {
                    $scope.close();
                }
            };

            $scope.scrollToTop = () => {
                $window.scroll(0, 0);
            };

            $scope.setUpPageObjs = function () {
                $scope.industrySet = false;
                $scope.getIndustries();
                // SETUP PAGE
                $scope.setupPurchaseForm = {
                    orgType: {
                        name: 'Choose your organization type',
                    },
                };

                $scope.errorMessagesAll = {
                    firstName: {
                        required: 'Type in your first name',
                    },
                    lastName: {
                        required: 'Type in your last name',
                    },
                    email: {
                        required: 'Please enter a valid email',
                        duplicate: 'This email address already exists, please sign in',
                    },
                    pass: {
                        required: 'Please enter a password',
                        passLength: 'Password must be between 8 and 60 characters',
                    },
                    confirmPass: {
                        required: 'Please re-enter your password',
                        matchPass: 'The passwords do not match',
                    },
                    orgName: {
                        required: 'Type in your organization name',
                        duplicate: 'A portal with this organization name already exists',
                    },
                    orgType: {
                        required: 'Select your organization type',
                    },
                    customUrl: {
                        required: 'Type in your custom URL',
                        symbols: 'Custom URLs can only contain letters, numbers, and hyphens (-)',
                        duplicate: 'A portal with this custom URL already exists',
                    },
                };

                $scope.setupPurchaseForm = {
                    orgType: {
                        name: 'Choose your organization type',
                    },
                };

                $scope.errorMessages = {
                    firstName: '',
                    lastName: '',
                    email: '',
                    pass: '',
                    confirmPass: '',
                    orgName: '',
                    orgType: 'Select your organization type',
                    customUrl: '',
                };
            };

            /**
             * Set error message for given field based on priority of errors
             *
             * @param {String} field - Field name (must match name on input field on form)
             */
            $scope.setErrorMessage = (field) => {
            // Do nothing if $scope vars not ready
                if (!Object.keys($scope.errorMessages).length || !Object.keys($scope.errorMessagesAll).length) {
                    return;
                }
                const priority = {
                    required: 100,
                    passLength: 50,
                    matchPass: 10,
                    symbols: 20,
                    duplicate: 10,
                    default: 0,
                };
                const errors = Object.keys($scope.setupPurchaseForm.form[field].$error);
                let maxError = 'default';
                errors.forEach((error) => {
                    if (priority[maxError] < priority[error]) {
                        maxError = error;
                    }
                });
                if (maxError === 'default') {
                    return;
                }
                $scope.errorMessages[field] = $scope.errorMessagesAll[field][maxError];
            };

            /**
             * Determines whether to show error on template
             *
             * @param {Object} fieldObj - field object on form
             */
            // Might normally go in template, but Object.keys() not working there
            $scope.isShowError = (fieldObj) => {
                if (fieldObj) {
                    $scope.setErrors();
                    return Object.keys(fieldObj.$error).length;
                }
                return 0;
            };

            /**
             * Wrapper for angularJS $setValidity
             *
             * @param {String} field - Name attribute of input field
             * @param {String} errorName - Name of error
             * @param {Boolean} isValid - true if error is being removed and set to a valid state
             */
            $scope.setValidity = (field, errorName, isValid) => {
                $scope.setupPurchaseForm.form[field].$setValidity(errorName, isValid, 'setupPurchasePlan');
            };

            $scope.setErrors = () => {
                // Required errors are set by AngularJS
                if ($scope.setupPurchaseForm.pass !== $scope.setupPurchaseForm.confirmPass) {
                    $scope.setValidity('confirmPass', 'matchPass', false);
                } else {
                    $scope.setValidity('confirmPass', 'matchPass', true);
                }

                if ($scope.setupPurchaseForm.pass && ($scope.setupPurchaseForm.pass.length < 8 || $scope.setupPurchaseForm.pass.length > 60)) {
                    $scope.setValidity('pass', 'passLength', false);
                } else {
                    $scope.setValidity('pass', 'passLength', true);
                }

                // eslint-disable-next-line no-undef
                if (!validateSlug($scope.setupPurchaseForm.customUrl)) {
                    $scope.setValidity('customUrl', 'symbols', false);
                } else {
                    $scope.setValidity('customUrl', 'symbols', true);
                }

                $scope.setErrorMessage('firstName');
                $scope.setErrorMessage('lastName');
                $scope.setErrorMessage('email');
                $scope.setErrorMessage('pass');
                $scope.setErrorMessage('confirmPass');
                $scope.setErrorMessage('orgName');
                $scope.setErrorMessage('customUrl');
            };

            // Watch the form and manually set some custom validation errors
            if ($scope.step === 'Setup') {
                $scope.$watch('setupPurchaseForm.form', $scope.setErrors, true);
            }

            // Scrolls to the first input that is invalid on the form
            $scope.scrollToError = () => {
                const errEl = $document[0].querySelector('form[name="setupPurchaseForm.form"] .ng-invalid');
                if (errEl) {
                    $window.scrollTo(0, errEl.offsetTop - 75);
                    return true;
                }
                return false;
            };

            // Checks and validates the account setup form
            $scope.validateSetupPage = () => {
                $q.all([
                    ajax.get('/api/business/slugExists', { slug: $scope.setupPurchaseForm.customUrl }),
                    ajax.get('/api/user/email/exists', { email: $scope.setupPurchaseForm.email }),
                    ajax.get('/api/organization/name/exists', { orgName: $scope.setupPurchaseForm.orgName }),
                ]).then(function (data) {
                    $scope.clickedValidate = true;
                    var uniqueFields = ['customUrl', 'email', 'orgName'];
                    uniqueFields.forEach(function (value, i) {
                        if (data[i].exists) {
                            $scope.setValidity(value, 'duplicate', false);
                        } else {
                            $scope.setValidity(value, 'duplicate', true);
                        }
                    });
                    if (!$scope.industrySet) {
                        $scope.industryError = true;
                    }
                    if (!$scope.setupPurchaseForm.form.$valid || !$scope.industrySet || Object.keys($scope.setupPurchaseForm.form.$error).length) {
                        $scope.scrollToError();
                        $scope.setErrors();
                        $scope.submittingForm = false;
                        return;
                    }
                    $scope.stepIndex += 1;
                    $scope.step = $scope.stepNames[$scope.stepIndex];

                    // track lead in hubspot
                    if (!$scope.businessId) {
                        const purchaseParams = {
                            first_name: $scope.setupPurchaseForm.firstName,
                            last_name: $scope.setupPurchaseForm.lastName,
                            email: $scope.setupPurchaseForm.email,
                            org: $scope.setupPurchaseForm.orgName,
                        };
                        ajax.post('/api/lead/purchase', purchaseParams);
                    }
                });
            };

            $scope.getPrice = function () {
                $scope.price = $scope.selectedPackage.price.toString();
                if ($scope.flow === 'upgrade') {
                    if ($scope.selectedPackage.name === $scope.currentPackage.name) {
                        $scope.price = '0';
                        return;
                    }
                    var daysLeft = config.params.daysLeft;
                    var costPerDay = ($scope.selectedPackage.price - $scope.currentPackage.price) / 365;
                    $scope.price = (daysLeft * costPerDay).toFixed(2).toString();
                }
            };

            $scope.getContactIntervalsAndPrice = function () {
                pricing.contacts.forEach((contacts) => {
                    const numContacts = contacts.contacts;
                    $scope.pricePerContact.push('$' + (contacts.price / numContacts).toFixed(2));
                    if (numContacts === 0 || numContacts < 1000) {
                        $scope.contactIntervals.push(numContacts.toString());
                    } else {
                        $scope.contactIntervals.push((numContacts / 1000).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + 'k');
                    }
                });
            };

            $scope.setCreditCardSelected = function (selected) {
                if (!$scope.newCreditCardSelected) {
                    logEventService.addEvent(logEventPLGFlow + ' - Add New Card clicked', 'PLG');
                }
                $scope.newCreditCardSelected = selected;
            };

            $scope.loadStripe = function () {
                // loads CVC field for payment page of upgrade flow
                if (!$window.Stripe) {
                    $timeout($scope.loadStripe, 100);
                    return;
                }
                stripe = $window.Stripe(config.stripe);
                const elements = stripe.elements();
                cvcErrorElement = $document[0].querySelector('#cvc-error');
                const style = {
                    base: {
                        color: '#28292C',
                        fontFamily: 'Lato, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        '::placeholder': {
                            color: '#696A72',
                            fontStyle: 'italic',
                        },
                    },
                    invalid: {
                        fontFamily: 'Lato, sans-serif',
                        color: '#C8321A',
                    },
                };

                cardCvcElement = elements.create('cardCvc', {
                    style: style,
                });
                cardCvcElement.mount('#cvc-field');

                cardCvcElement.on('change', function (event) {
                    cvcErrorElement.classList.remove('visible');

                    if (event.error) {
                        cvcErrorElement.textContent = '* ' + event.error.message;
                        cvcErrorElement.classList.add('visible');
                    }
                });
            };

            $scope.submitExtension = (token) => {
                /**
                 * For each request params we need:
                 * EOTE -> tier, extra_contacts, business, stripe token
                 * PSUB -> tier, extra contacts, set up form data (first name, last name, email, password, orgName, industry id, slug), stripe token
                 * PPEP -> tier, extra contacts, business, stripe token
                 * BSUB -> tier, extra contacts, business, stripe token
                 *
                 * four different flows: extend, purchase with account, purchase without account, upgrade
                 */
                if ($scope.submittingForm) {
                    return;
                }

                $scope.submittingForm = true;

                var params = {};
                var postLink = '';

                params = {
                    tier: $scope.selectedPackage.key,
                    extra_contacts: $scope.selectedContactExtra.contacts,
                    stripe_token: token ? token.id : undefined,
                    setup_info: $scope.setupPurchaseForm,
                    business_id: $scope.businessId,
                    total_cost: $scope.selectedPackage.price + $scope.selectedContactExtra.price,
                    prorated_cost: $scope.price,
                    cvc_check: token ? token.type === 'cvc_update' : false,
                };

                switch ($scope.flow) {
                    case 'extend':
                        postLink = '/freeTrial/extend';
                        break;
                    case 'purchase':
                        postLink = '/purchasePlan';
                        break;
                    case 'upgrade':
                        postLink = '/api/package/upgrade';
                        break;
                    default:
                        break;
                }

                ajax.post(postLink, params).then(() => {
                    $scope.portalUrl = config.params.purchaseRedirectUrl ? config.params.purchaseRedirectUrl : '/account';

                    $scope.stepIndex += 1;
                    $scope.step = $scope.stepNames[$scope.stepIndex];
                    if ($scope.step === 'Complete') {
                        logEventService.addEvent(logEventPLGFlow + ' - Payment Complete', 'PLG');
                    }
                }).catch(function (data) {
                    if (data && data.message) {
                        $rootScope.$broadcast('open-message', data.message);
                    }
                }).finally(() => {
                    $scope.submittingForm = false;
                });
            };

            $scope.paymentHelp = function () {
                $scope.sendEmailToSales('payment');
                logEventService.addEvent(logEventPLGFlow + ' - Payment help clicked', 'PLG');
            };

            $scope.trackGoToPortal = function () {
                logEventService.addEvent(logEventPLGFlow + ' - Confirm Go to Portal clicked', 'PLG');
            };

            $scope.trackSignIn = function () {
                logEventService.addEvent(logEventPLGFlow + ' - Setup Sign In clicked', 'PLG');
            };

            $rootScope.resetFlow = function () {
                $scope.selectedPackage = $scope.allPackages[0];
                $scope.stepIndex = 0;
                $scope.step = $scope.stepNames[0];
                $scope.newCreditCardSelected = false;
                if ($scope.creditCard) {
                    $document[0].getElementById('existing-credit-card').checked = 'checked';
                }
                $document[0].getElementById('agreeTerms-checkbox').checked = false;
            };

            $scope.init();
        }]);
}());
